// API service for Aquarelles frontend

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://aquarelles-api.xavier-71b.workers.dev'
  : 'http://localhost:8787'; // Wrangler dev default port

class ApiService {
  async fetchWithErrorHandling(url, options = {}) {
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'API request failed');
      }

      return data.data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Get all podcasts
  async getPodcasts(options = {}) {
    const params = new URLSearchParams();
    
    if (options.limit) {
      params.append('limit', options.limit);
    }

    const url = `${API_BASE_URL}/api/podcasts${params.toString() ? `?${params}` : ''}`;
    return this.fetchWithErrorHandling(url);
  }

  // Get podcast by ID
  async getPodcast(id) {
    const url = `${API_BASE_URL}/api/podcasts/${id}`;
    return this.fetchWithErrorHandling(url);
  }

  // Search podcasts
  async searchPodcasts(query) {
    const params = new URLSearchParams({ q: query });
    const url = `${API_BASE_URL}/api/search?${params}`;
    return this.fetchWithErrorHandling(url);
  }

  // Health check
  async healthCheck() {
    const url = `${API_BASE_URL}/api/health`;
    try {
      const response = await fetch(url);
      return response.ok;
    } catch (error) {
      console.error('Health check failed:', error);
      return false;
    }
  }

  // Get audio URL (for the audio player)
  getAudioUrl(audioPath) {
    // Remove leading slash if present
    const cleanPath = audioPath.startsWith('/') ? audioPath.slice(1) : audioPath;
    return `${API_BASE_URL}/${cleanPath}`;
  }

  // Get image URL (for thumbnails)
  getImageUrl(imagePath) {
    // Remove leading slash if present
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    return `${API_BASE_URL}/${cleanPath}`;
  }
}

// Create and export singleton instance
const apiService = new ApiService();
export default apiService;